import icon1 from "src/assets/icons/opportunities/buyerOpportunities/icon-1.svg";
import icon2 from "src/assets/icons/opportunities/buyerOpportunities/icon-7.svg";
import icon3 from "src/assets/icons/opportunities/buyerOpportunities/icon-8.svg";
import icon4 from "src/assets/icons/opportunities/buyerOpportunities/icon-9.svg";
import icon5 from "src/assets/icons/opportunities/buyerOpportunities/icon-10.svg";
import icon6 from "src/assets/icons/opportunities/buyerOpportunities/icon-11.svg";
import icon7 from "src/assets/icons/opportunities/sellerOpportunities/icon-2.svg";
import icon8 from "src/assets/icons/opportunities/sellerOpportunities/icon-3.svg";
import icon9 from "src/assets/icons/opportunities/sellerOpportunities/icon-4.svg";
import icon10 from "src/assets/icons/opportunities/sellerOpportunities/icon-5.svg";
import icon11 from "src/assets/icons/opportunities/sellerOpportunities/icon-6.svg";
import { Opportunity } from "./types";
import {
  buyerOpportunities,
  revolutionizeApproachTrns,
  sellerOpportunities,
} from "../trns";

export const BUYERS_OPPORTUNITIES_OPTIONS: Opportunity[] = [
  {
    id: 1,
    icon: { url: icon1, title: "icon" },
    title: { i18nKey: buyerOpportunities.quickStartOpportunityTitle },
    description: { i18nKey: buyerOpportunities.quickStartOpportunityDesc },
  },
  {
    id: 2,
    icon: { url: icon2, title: "icon" },
    title: { i18nKey: buyerOpportunities.supportOpportunityTitle },
    description: { i18nKey: buyerOpportunities.supportOpportunityDesc },
  },
  {
    id: 3,
    icon: { url: icon3, title: "icon" },
    title: { i18nKey: buyerOpportunities.riskMinimizationOpportunityTitle },
    description: {
      i18nKey: buyerOpportunities.riskMinimizationOpportunityDesc,
    },
  },
  {
    id: 4,
    icon: { url: icon4, title: "icon" },
    title: { i18nKey: buyerOpportunities.timeSavingsOpportunityTitle },
    description: {
      i18nKey: buyerOpportunities.timeSavingsOpportunityDesc,
    },
  },
  {
    id: 5,
    icon: { url: icon5, title: "icon" },
    title: { i18nKey: buyerOpportunities.expansionOpportunityTitle },
    description: {
      i18nKey: buyerOpportunities.expansionOpportunityDesc,
    },
  },
  {
    id: 6,
    icon: { url: icon6, title: "icon" },
    title: { i18nKey: buyerOpportunities.successOpportunityTitle },
    description: {
      i18nKey: buyerOpportunities.successOpportunityDesc,
    },
  },
];

export const SELLERS_OPPORTUNITIES_OPTIONS = [
  {
    id: 1,
    icon: { url: icon7, title: "icon" },
    title: { i18nKey: sellerOpportunities.additionalIncomeOpportunityTitle },
    description: {
      i18nKey: sellerOpportunities.additionalIncomeOpportunityDesc,
    },
  },
  {
    id: 2,
    icon: { url: icon8, title: "icon" },
    title: { i18nKey: sellerOpportunities.brandExpansionOpportunityTitle },
    description: {
      i18nKey: sellerOpportunities.brandExpansionOpportunityDesc,
    },
  },
  {
    id: 3,
    icon: { url: icon9, title: "icon" },
    title: { i18nKey: sellerOpportunities.scalingOpportunityTitle },
    description: {
      i18nKey: sellerOpportunities.scalingOpportunityDesc,
    },
  },
  {
    id: 4,
    icon: { url: icon10, title: "icon" },
    title: { i18nKey: sellerOpportunities.collaborationOpportunityTitle },
    description: {
      i18nKey: sellerOpportunities.collaborationOpportunityDesc,
    },
  },
  {
    id: 5,
    icon: { url: icon11, title: "icon" },
    title: { i18nKey: sellerOpportunities.minimalRiskOpportunityTitle },
    description: {
      i18nKey: sellerOpportunities.minimalRiskOpportunityDesc,
    },
  },
];

export const REVOLUTIONIZE_APPROACH_DESCRIPTION_PARAGRAPHS = [
  {
    id: 1,
    text: {
      i18nKey: revolutionizeApproachTrns.paragraphFirst,
    },
  },
  {
    id: 2,
    text: {
      i18nKey: revolutionizeApproachTrns.paragraphSecond,
    },
  },
  {
    id: 3,
    text: {
      i18nKey: revolutionizeApproachTrns.paragraphThird,
    },
  },
  {
    id: 4,
    text: {
      i18nKey: revolutionizeApproachTrns.paragraphFourth,
    },
  },
];
